let baseUrl = ''
if (process.env.NODE_ENV === 'development') {
  baseUrl = '/xkh/teacherapi'
} else {
  baseUrl = '//xkhteacher.aixuexi.com/xkh/teacherapi'
}

export default {
  getUploadToken: `${baseUrl}/correction/image/tokenAndBusiness`,
  getCorrectionStudentlist: `${baseUrl}/correction/operate/studentlist`,
  getStudentSubmitlist: `${baseUrl}/correction/student/pathlog`,
  getCorrectionList: `${baseUrl}/correction/teacher/operatenew`,
  postCorrectionList: `${baseUrl}/correction/teacher/operate`,
  // 批改左侧小组列表
  getGroupList: `${baseUrl}/correction/course/list`,
  // 批改右侧列表
  getLessonList: `${baseUrl}/correction/lesson/list`,
  // 查询统计详情
  getCountList: `${baseUrl}/correction/student/studentCount`,
  // 解锁
  unlockLesson: `${baseUrl}/course/lesson/unlock`,
  // 获取题解视频
  teacherExplainVedio: `${baseUrl}/course/lesson/findTeacherExplainVedio`,
  // 讲次-日积月累答案
  workwordAnswer: `${baseUrl}/lesson/workword/answer/4`,
  // 讲次-融汇贯通答案
  firstExamWordAnswer: `${baseUrl}/lesson/firstExamWord/answer`,
  // 讲次列表刷新
  getLessonRefreshList: `${baseUrl}/correction/lesson/newlist`,
  // 获取环节tabs数据
  giveThumb: `${baseUrl}/correction/student/giveThumb`,
  // 创建-评语 https://yapi.aixuexi.com/project/42/interface/api/196805
  addComment: `${baseUrl}/comment/add`,
  // 更新-评语 https://yapi.aixuexi.com/project/42/interface/api/196808
  updComment: `${baseUrl}/comment/update`,
  // 删除-评语 https://yapi.aixuexi.com/project/42/interface/api/196811
  delComment: `${baseUrl}/comment/operate`,
  // 评语-列表 https://yapi.aixuexi.com/project/42/interface/api/196814
  getComment: `${baseUrl}/comment/view`,
  // 解锁课前学 https://yapi.aixuexi.com/project/42/interface/api/197345
  unlockBeforeLesson: `${baseUrl}/course/courseware/unlock`,
  // 备课-课件片段配信息查询 https://yapi.aixuexi.com/project/42/interface/api/196814
  getPrepareInfo: `${baseUrl}/course/prepare/courseware/info`,
  // 备课-课件片段配信息保存 https://yapi.aixuexi.com/project/42/interface/api/197324
  savePrepareInfo: `${baseUrl}/course/prepare/courseware/save`,
  // 备课-根据讲次查询补充资料 https://yapi.aixuexi.com/project/42/interface/api/197459
  getSupMaterial: `${baseUrl}/courseAssist`
}
